import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import Selector from '../../../../components/Selector/Selector'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'
import useButtonSelector from '../../../../utils/hooks/useButtonSelector/useButtonSelector'
const filterOptions = [
  { id: '', value: '', label: 'Todos' },
  { id: 'AC', value: 'AC', label: 'Activos' },
  { id: 'SU', value: 'SU', label: 'Suspendidos' },
  { id: 'EP', value: 'EP', label: 'En Proceso' },
  { id: 'DV', value: 'DV', label: 'Desvinculado' },
]

const options = [
  {
    id: 0,
    value: 'excel',
    label: 'Excel',
  },
  {
    id: 1,
    value: 'pdf',
    label: 'PDF',
  },
]

export default function NnReport() {
  const [status, setStatus] = useState(null)
  const { selected, onSelectedChange } = useButtonSelector(options)
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const onChangeStatus = (value) => {
    setStatus(value)
  }

  const [nnData, setNNData] = useState(null)

  const handleGetNNData = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .nnReports(status)
      .then((res) => {
        setNNData(res.data)
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(error.response.data.error, error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
    handleCLoseLoading()
  }

  const handleGetReport = async () => {
    if (!selected) return

    const extension = selected.value === 'pdf' ? 'pdf' : 'xlsx'

    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .nnReportsExport(status, selected.value)
      .then((res) => {
        const url = URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Cuenta_NN_empresa.${extension}`)
        document.body.appendChild(link)
        link.click()
        handleSetTitle('Reporte descargado con exito', 200)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            Continuar
          </Button>,
        )
        handleOpen()
        handleCLoseLoading()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle('No se pudo exportar el reporte.', error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  return (
    <VStack alignItems="flex-start">
      <HStack alignItems="flex-end">
        <VStack alignItems="flex-start">
          <Text variant="body2">Filtrar por estado</Text>
          <Box w="200px">
            <Selector
              options={filterOptions}
              onChange={onChangeStatus}
              isClearable
            />
          </Box>
        </VStack>
        <VStack paddingStart={5}>
          <Button borderRadius={10} onClick={handleGetNNData}>
            Buscar
          </Button>
        </VStack>
      </HStack>
      {nnData?.lTarjetas && (
        <HStack alignItems="flex-end" paddingTop={5}>
          <VStack alignItems="flex-start">
            <Text variant="body2" fontWeight="bold">
              Descargar en formato
            </Text>
            <Box w="200px">
              <Selector
                isClearable={false}
                placeholder="Opciones"
                options={options}
                onChange={onSelectedChange}
              />
            </Box>
          </VStack>
          <VStack paddingStart={5}>
            <Button onClick={handleGetReport}>Descargar informe</Button>
          </VStack>
        </HStack>
      )}
    </VStack>
  )
}
